<dialog
  #dialog
  qai-dialog
  [description]="dialogDescription"
  [heading]="modalHeading"
  (afterClose)="handleCloseClick()"
>
  <qai-field
    [label]="fieldLabel"
    [description]="selectedUsers.length > 0 ? '' : searchFieldDescription"
  >
    <qai-tree-select
      *ngIf="allTeamsWithUsers.length === 0"
      [treeData]="[]"
    ></qai-tree-select>

    <qai-tree-select
      *ngIf="allTeamsWithUsers.length !== 0"
      [treeData]="allTeamsWithUsers"
      (selectionsSave)="onSelectionSave($event)"
      maxHeight="30dvh"
    ></qai-tree-select>

    <span qaiSlot="label" *ngIf="selectedUsers.length > 0">
      <button qai-link class="remove-all-button" (click)="onRemoveAll()">
        Remove all
      </button>
    </span>
  </qai-field>

  <div class="action-button-container">
    <button
      qai-button
      kind="secondary"
      [size]="'medium'"
      (click)="handleCloseClick()"
    >
      Cancel
    </button>
    <button
      qai-button
      size="medium"
      kind="primary"
      [disabled]="networkRequestInProgress || this.selectedUsers.length === 0"
      (click)="handleSuccessClick()"
    >
      {{ modalButtonText }}
    </button>
  </div>
</dialog>
